import { render, staticRenderFns } from "./ColumnsSelector.vue?vue&type=template&id=7132e51c&"
import script from "./ColumnsSelector.vue?vue&type=script&lang=js&"
export * from "./ColumnsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports